/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TileRateProvision_jsonld = {
    readonly '@context'?: string | Record<string, any>;
    readonly '@id'?: string;
    readonly '@type'?: string;
    type?: TileRateProvision_jsonld.type;
    name?: string;
};
export namespace TileRateProvision_jsonld {
    export enum type {
        UNKNOWN = 'Unknown',
        NO_MEAL = 'NoMeal',
        BREAKFAST = 'Breakfast',
        HALF_BOARD = 'HalfBoard',
        FULL_BOARD = 'FullBoard',
        ALL_INCLUSIVE = 'AllInclusive',
        SOFT_ALL_INCLUSIVE = 'SoftAllInclusive',
        LUNCH = 'Lunch',
        DINNER = 'Dinner',
    }
}
